import { useMemo } from 'react';

//* HOC's
import { withDataContext } from 'context';

//* Components
import Page from 'components/common/Page';
import Anchor from 'components/layouts/Anchor';
import Feedback from 'components/common/Feedback';
import Container from 'components/common/Container';
import RelatedBlogPosts from 'components/common/RelatedBlogPosts';

const PlanYourTrip = ({ singlePage, pageParams, selectedLang }) => {
	const pageData = useMemo(() => singlePage?.[pageParams.selectedSlug]?.[selectedLang], [singlePage, pageParams, selectedLang]);

	return (
		<Page
			meta={pageData?.meta}
			transparentHeader={pageParams.transparentHeader && !pageData}
		>
			{pageData && (
				<Anchor
					tips={pageData.components?.[1].data}
					{...pageData.components?.[0].data}
					pageId={pageData.id}
					type={pageData.type}
				/>
			)}

			{pageData && (
				<Container section>
					<Feedback
						type={pageData?.feedbackType}
						typeId={pageData.id}
					/>
				</Container>
			)}

			{pageData?.articles?.length > 0 && <RelatedBlogPosts articles={pageData.articles} />}
		</Page>
	);
};

export default withDataContext(PlanYourTrip, ['singlePage']);
